export default {"asyncApp":".style_30bf5f86-86a1-79ab-820d-da5d7c25_asyncApp"}